import type { HTTPFunctions } from '../types';

const ai = ({ post }: HTTPFunctions) => ({
  getMessageFromClaude: (message: string) => post<string>('/claude/messages', message),
});

export default ai;
